import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MicrositeContent } from '@/types/microsite';
import { micrositeService } from '@/services/microsite.service';
import { BrandHero } from '@/components/microsite/BrandHero';

export default function MicrositeHomePage() {
  const { shareId } = useParams<{ shareId: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState<MicrositeContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!shareId) {
      navigate('/p/error', { replace: true });
      return;
    }
    micrositeService
      .getContent(shareId)
      .then(setData)
      .catch(() => navigate('/p/error', { replace: true }))
      .finally(() => setLoading(false));
  }, [shareId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-[#bd9734] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!data) return null;

  const firstName = data.player.name.trim().split(/\s+/)[0];

  return (
    <div className="max-w-screen-sm mx-auto">
      <div className="-mx-0">
        <BrandHero
          fullBleed
          heightClass=""
          heightStyle={{ minHeight: 'calc(100vh - env(safe-area-inset-bottom))' }}
          title={`Welcome ${firstName},`}
          subtitle="We are excited to be a part of your game."
          primaryHref={`/p/${shareId}/report`}
          primaryLabel="View Report"
          secondaryHref={`/p/${shareId}/benefits`}
          secondaryLabel="View Membership Benefits"
        />
      </div>
    </div>
  );
}
